export default function LogoutPopup(props: any) {
  return (
    <div className="flex flex-col w-72 bg-white shadow-lg border rounded-md p-4 gap-4">
      <span className=" text-black text-base">
        Want to logout from previous selected broker?
      </span>
      <div className="flex justify-center gap-8">
        <button
          onClick={() => {props.setLogoutFromPrevBroker("Yes"); props.setShowBrokerLogoutPopup(false);}}
          className="px-[24px] py-[8px] text-[#7B5AEC] text-sm font-semibold font-sans rounded bg-[#7b5aec0d] hover:text-white hover:bg-[#7B5AEC]"
        >
          Yes
        </button>
        <button
          onClick={() => {props.setLogoutFromPrevBroker("No"); props.setShowBrokerLogoutPopup(false);}}
          className="px-[24px] py-[8px] text-[#7B5AEC] text-sm font-semibold font-sans rounded bg-[#7b5aec0d] hover:text-white hover:bg-[#7B5AEC]"
        >
          No
        </button>
      </div>
    </div>
  );
}
